import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { useSignups } from "Signups/state.js";

import FnrProgressBar from "UI/FnrProgressBar2";

import { getAvailableSlots } from "./utils/getAvailableSlots";

ProgressBarArea.propTypes = {
  signupItem: PropTypes.object,
};

export default function ProgressBarArea({ signupItem }) {
  const [state] = useSignups();

  const { totalSlots, slotsTaken } = signupItem;
  const { entitySingle, entityPlural } =
    state.currentSignupList.signupListVerbs;

  const availableSlots = getAvailableSlots(signupItem);
  const isPlural = availableSlots !== 1;

  if (signupItem?.showRespondentsCount === false) return null;

  return (
    <Wrapper data-cy='SignupItem_ProgressBar'>
      <Labels>
        <Label>
          {availableSlots} {isPlural ? entityPlural : entitySingle} available
        </Label>
        <Label>{totalSlots}</Label>
      </Labels>
      <FnrProgressBar count={slotsTaken} max={totalSlots} delay={0.4} />
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const Labels = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 4px;
`;

const Label = styled.div`
  opacity: 0.69;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #2f3f4f;
  letter-spacing: -0.04px;
`;
